
import { computed, defineComponent, markRaw, nextTick, onBeforeUnmount, onMounted, ref, watchEffect } from 'vue'
import * as echarts from 'echarts';
import { getThisMonthStartTime, getThisWeekStartTime, getThisYearStartTime, getTodayNowTime, getTodayStartTime } from '@/utils/date.util';
import { ThemeModule } from '@/store/modules/theme.module';
import OpenTicketReportApi from '@/api/OpenTicketReportApi';

export default defineComponent({
  setup () {
    let timer = 0
    const ticketTypeList = ref<any>([]);
    const myEcharts = ref<echarts.ECharts>()
    const option = {
      tooltip: {
        trigger: 'item',
        borderWidth: 0,
        extraCssText: 'background: linear-gradient(304.17deg, rgba(36, 176, 255, 0.6) -6.04%, rgba(9, 67, 132, 0.6) 85.2%); border-radius: 6px',
        textStyle: {
          fontSize: 12,
          color: 'var(--main-font-color)'
        }
      },
      color: ['#0A9CFD', '#52C5FF', '#0E42D2'],
      legend: {
        show: false
      },
      series: [
        {
          name: '工单类型',
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['55.5%', '74.4%'],
          left: '0%',
          top: '10%',
          minAngle: 0,
          avoidLabelOverlap: true,
          showEmptyCircle: false,
          label: {
            show: true,
            position: 'center',
            formatter: '{d}%'
          },
          labelLine: {
            show: true
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 20
            }
          }
        }
      ]
    }
    const timeRef = ref<any>('THIS_DAY')
    const timeMap = new Map([
      ['THIS_DAY', '今日'],
      ['THIS_WEEK', '本周'],
      ['THIS_MONTH', '本月'],
      ['THIS_YEAR', '本年']
    ])
    const timeFilter = computed(() => {
      return (value) => {
        return timeMap.get(value + '')
      }
    })
    const themeColors = computed(() => ThemeModule.themeColors)

    watchEffect(() => {
      myEcharts.value && myEcharts.value.setOption({
        title: {
          textStyle: {
            color: themeColors.value['font-color-08']
          }
        },
        legend: {
          textStyle: {
            color: themeColors.value['font-color-08']
          }
        },
        series: [{
          label: {
            color: themeColors.value['font-color-06']
          }
        }]
      })
    })

    function renderChart () {
      const chartDom = document.getElementById('ticket-type') as HTMLElement;
      myEcharts.value = markRaw(echarts.init(chartDom))
      myEcharts.value.setOption(option)
      chartDom.removeAttribute("_echarts_instance_")
    }

    function statisticsTicketTypePercentage () {
      let startDate: string | null = null
      const endDate: string | null = getTodayNowTime()
      if (timeRef.value === 'THIS_DAY') {
        startDate = getTodayStartTime()
      } else if (timeRef.value === 'THIS_WEEK') {
        startDate = getThisWeekStartTime()
      } else if (timeRef.value === 'THIS_MONTH') {
        startDate = getThisMonthStartTime()
      } else if (timeRef.value === 'THIS_YEAR') {
        startDate = getThisYearStartTime()
      }

      OpenTicketReportApi.statisticsTicketTypePercentage({
        startDate,
        endDate
      }).then((res:any) => {
        const data = (res || []).map(item => ({
          value: item.number || 0,
          name: item.ticketTypeText || '未知'
        }));
        ticketTypeList.value = data;
        myEcharts.value && myEcharts.value.setOption({
          series: [
            {
              label: {
                position: 'outside',
                formatter: '{d}%'
              },
              data: data
            }
          ]
        })
        timer = setTimeout(() => {
          statisticsTicketTypePercentage()
        }, 5000);
      })
    }

    function setPeriod (status: 'THIS_DAY' | 'THIS_WEEK' | 'THIS_MONTH' | 'THIS_YEAR') {
      timeRef.value = status
      timer && clearTimeout(timer)
      statisticsTicketTypePercentage()
    }

    function reasize () {
      myEcharts.value && myEcharts.value.resize()
    }

    onMounted(() => {
      renderChart()
      statisticsTicketTypePercentage()
      window.addEventListener('resize', reasize)
    })

    onBeforeUnmount(() => {
      clearTimeout(timer)
    })

    return {
      timeRef,
      timeFilter,
      ticketTypeList,
      setPeriod
    }
  }
})
